/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentWorkflowTemplateType {
    SIGNATURE_REQUIRED = 'SIGNATURE_REQUIRED',
    FORM_INPUT = 'FORM_INPUT',
    READ_ONLY = 'READ_ONLY',
    SIGNABLE_FORM = 'SIGNABLE_FORM',
}
